import "./index.css";
import styled, { createGlobalStyle } from "styled-components";
import { LOGO } from "@assets";

const GlobalStyles = createGlobalStyle`
* {
  margin: 0;
  font-family: 'MyanmarSansPro', 'Roboto';
}

body {
  display: flex;
  align-items: center;
  justify-content: center;
}

#root {
  width: 100vw;
  max-width: 480px;
  min-height: 100vh;
  background: ${(props) => props.theme.backgroundColor};   
}

.ant-spin-dot i {
  background-color: ${(props) => props.theme.primaryColor} !important;
}

.ant-modal:not(.custom-calendar-modal):not(.lang-modal):not(.pocket-money-modal) {
    
  .ant-modal-content {
    padding: 32px 24px !important;
    border-radius: 20px;
    background: #FFF;
  }

  .ant-modal-body {
    padding: 12px 0 !important;
    color: #6D7F8A !important;
    font-size: 14px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    line-height: normal !important;
  }

  .ant-modal-header {
    background: transparent !important;
  }

  .ant-modal-title {
    background-color: transparent !important;
    color: #0161BF !important;
    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    line-height: normal !important;
  }

  .ant-modal-footer {
    display: flex;
    justify-content: center;
    gap: 16px;

    .ant-btn {
      flex: 1;
      width: 100%;
      margin: 0 !important;
      height: 44px !important;
      border-radius: 16px !important;
      font-weight: 400 !important;
      font-size: 14px !important;
    }

    .ant-btn-default {
      border: none !important;
      background: #DEEDFF !important;
    }
    .ant-btn-primary {
      background: linear-gradient(90deg, #0060BE 0%, #04AEED 100%);
      border: none !important;
    }
  }
}

.ant-btn-primary:not(.ant-btn-dangerous) {
  background: ${(props) => props.theme.buttonColor};
  border-radius: 26px;
  width: 100%;
  border: none !important;

  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  color: #FFFFFF !important;

  :hover {
    background: ${(props) => props.theme.buttonHoverColor};
    border: none !important;
  }

  :disabled {
    color: #FFFFFF;

    :hover {
      background: ${(props) => props.theme.buttonColor};
    }
  }
}

.ant-btn-primary:not(:disabled):not(.ant-btn-disabled):hover{
  background: ${(props) => props.theme.buttonHoverColor};
}

.ant-btn-default {
background-color: #FFFFFF !important;
color: #000000 !important;
border: 2px solid #0095DA !important;
border-radius: 26px;

font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 1.5;

  :hover {
    background-color: #FFFFFF !important;
    color: #000000 !important;
    border: 2px solid #0095DA !important;
  }
}

.ant-table-wrapper {
  
  tr:nth-child(2n) {
    td {
      background-color: #E1CCE0;
    }

    :hover {
      td {
        background-color: #E1CCE0 !important;
      }
    }
  }

  tr {
      >td {
        background-color: ${(props) => props.theme.backgroundColor};

        font-size: 14px;
        font-weight: normal;
        color: #000000;

        :first-child, :last-child {
          padding: 8px 24px !important;
        }
    }

    :hover {
      >td {
        background-color: ${(props) => props.theme.backgroundColor} !important;
      }
    }
  }

  tr>th {
    background-color: #71207C !important;
    font-size: 14px !important;
    font-weight: normal !important;
    color: #FFFFFF !important;

    ::before {
      display: none;
    }

    :first-child {
      border-start-start-radius: 5px !important;
      border-end-start-radius: 5px !important;
      padding: 8px 24px !important;
    }

    :last-child {
      border-start-end-radius: 5px !important;
      border-end-end-radius: 5px !important;
      padding: 8px 24px !important;
    }
  }
}

.ant-radio-wrapper .ant-radio-checked {
    
  ::after {
    border: 1px solid ${(props) => props.theme.primaryColor};
  }

  .ant-radio-inner {
    border-color: ${(props) => props.theme.primaryColor};
    background-color: ${(props) => props.theme.primaryColor};
  }
}

.ant-picker-calendar {
    .ant-radio-group {
        display: none !important;
    }
}

.ant-notification-notice {
  padding: 12px !important;
}

.ant-notification-notice-close {
  top: 12px !important;
}

.ant-notification-notice-description {
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

/* Hide scrollbar for Chrome, Safari and Opera */
::-webkit-scrollbar {
    display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
-ms-overflow-style: none;  /* IE and Edge */
scrollbar-width: none;  /* Firefox */

.otp-length-8 {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  gap: 5px;

  @media screen and (max-width: 290px) {
    flex-wrap: wrap;
  }
}

.otp-length-6 {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  gap: 7px;

  @media screen and (max-width: 290px) {
    flex-wrap: wrap;
  }
}


.custom-calendar-modal {

  .ant-modal-footer {
      text-align: center;
  }

  @media screen and (max-width: 325px) {
    .ant-modal-content {
      padding: 20px 0 !important;
    }
  }
  
}

.trx-history-dropdown {
  background-color: #EFEFEF;

  .ant-select-item-option {
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    color: #101415;
  }
}

.ant-drawer-content-wrapper {
    height: auto !important;
}

.ant-form-item-explain-error {
  font-size: 12px;
}

.ant-result {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .ant-result-title {
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 1.5;
    color: #0161BF;
  }

  .ant-result-subtitle {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    color: #000;
  }

  .ant-btn-primary {
    min-width: 170px;
    height: 40px;

    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    color: #FFF !important;
    background: linear-gradient(90deg, #0060BE 0%, #04AEED 100%) !important;

    :hover {
      color: #FFF !important;
      background: linear-gradient(90deg, #0060BE 0%, #04AEED 100%) !important;

    }
  }
}

.ant-input:focus::placeholder {
    color: transparent !important;
  }

.grecaptcha-badge { visibility: hidden; }
`;



export const Logo = styled.img.attrs({
  alt: "logo-img",
  src: LOGO,
})``;

export default GlobalStyles;
